import type {
  ChannelStylesheetResponseDto,
  GenerateChannelStylesheetArgs,
  GeneratedChannelStylesheet,
} from './channel-stylesheets.api.types';

// Both apps take the color without `#`; feedback-web reads the `web` channel type as a widget.
export function toApiChannelStylesheetUrl({ baseUrl, channelKind, primaryColor }: GenerateChannelStylesheetArgs) {
  const query = new URLSearchParams({
    channelType: channelKind === 'widget' ? 'web' : 'link',
    primaryColor: primaryColor.replace(/^#/, ''),
  });

  return `${baseUrl.replace(/\/+$/, '')}/create_channel_style_file?${query}`;
}

export function fromApiChannelStylesheet({
  content,
  filename,
}: ChannelStylesheetResponseDto): GeneratedChannelStylesheet {
  return { content, fileName: filename };
}
